// extracted by mini-css-extract-plugin
export default {"name":"wg0yVqJp","header":"beD0zHED","mobile":"mobile","desktop":"desktop","info":"SNIyrKFv","cover":"N94o4sT7","text":"Ocr7Pivn"};